<template>
  <div id="app">
    <div v-if="load_show">
      <load></load>
    </div>

    <headertop style="z-index:999"></headertop>
    <div class="topping" @click="topping_click()" style="cursor: pointer;">
      <img  src="../../../assets/Topping.png" style="width: 3.125rem;"></br>
      <!-- <i class="el-icon-arrow-up"></i><!-- </br> -->
      <span>置顶</span>
      </div>
    <div class="main"style="z-index:999">
      <el-col id="height2"  >
        <!-- 卡片-->
        <el-row id="text11" v-if="all_search.type=='video'">
          <el-row>
            <el-row style="margin: 1.25rem 0  ;">
              <span v-for="(item,index) in type_list_local" :key="index" @click="local_click(item.type)" >
                <span v-if="index+1!=type_list_local.length" style="font-weight: 900;cursor: pointer;">{{item.name}}
                <span style="margin: 0 5px;"> ></span>
                </span>
                <span v-else>{{item.name}}</span>
              </span>
            </el-row>
            <el-col :class="item.number=='0' ? 'eachc1' : 'eachc'" v-for="(item,index) in type_list" :key="index"  >
              <el-row v-if="item.number=='0'" >
                <div @click="get_type_click(item.num)">
                  <div style="border-radius: 0.3125rem; border: 1px solid #EBEEF5; background-color: #fff; height: 20vh; padding: 0.8rem  0.5rem; color: #303133;-webkit-transition: .3s;transition: .3s;">
                    <div class="imgh1"  id="img_h" style="cursor: pointer;">
                        <h4 style="font-family:font-family:汉仪宋韵朗黑W;    letter-spacing: 2px; color: rgb(50, 66, 116);padding:1rem;"> {{item.name}}</h4>
                    </div>
                    <div style="padding-top: 0.125rem;" >
                      <div >
                        <h6 class="left">课程顾问：某某某</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </el-row>
              <el-row v-else>
                <div>
                <el-card :body-style="{ padding: '10px' }">
                  <div class="imgh"  @click="video_see(item.serial_number,0,show.resource_type)">
                    <img v-if="item.img=='/uploads/company/video/default.jpg'" :src="'https://edu.zhiyaozhishi.com'+item.img"
                                      class="image">
                    <img v-else :src="item.img"
                      class="image">
                  </div>
                  <div style="padding: 5px;"  >
                     <h6 style="margin: 0;height: 35px;overflow: hidden;"> {{item.name}}</h6>
                      <el-row v-if="item.tag.length>0">
                        <el-col :span="3" :offset="1" v-if="item.tag[0]!=''">
                          <el-tag >{{item.tag[0][0]}}</el-tag>
                        </el-col>
                        <el-col :span="3" :offset="1" v-if="item.tag[1]!=''">
                          <el-tag type="success">{{item.tag[1][0]}}</el-tag>
                        </el-col>
                        <el-col :span="3" :offset="1" v-if="item.tag[2]!=''">
                          <el-tag type="info">{{item.tag[2][0]}}</el-tag>
                        </el-col>
                        <el-col :span="3" :offset="1" v-if="item.tag[3]!=''">
                          <el-tag type="warning">{{item.tag[3][0]}}</el-tag>
                        </el-col>
                        <el-col :span="3" :offset="1" v-if="item.tag[4]!=''">
                          <el-tag type="danger">{{item.tag[4][0]}}</el-tag>
                        </el-col>
                      </el-row>
                      <el-row v-else style="height: 2rem;width: 100%;">
                      </el-row>
                      <div class="bottom clearfix">
                        <h6 style="margin: 0;" class="left">{{item.u_time}}</h6>
                        <h6 style="margin: 0;" class="right">{{item.teacher}}</h6>
                      </div>
                  </div>
                </el-card>
                </div>
              </el-row>
            </el-col>
          </el-row>

        </el-row>
        <br />
      </el-col>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import load from '../../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        type_list_local:[],
        info:{
          brief:'消毒和环境监测是CCS的重要组成部分。为确保制药生产环境的控制保持一致，洁净区的消毒尤其重要。消毒程序应经过验证，证明消毒剂在特定使用方式和表面材料（或代表性材质）上的适用性和有效性，并应支持所制备溶液的使用有效期。环境监测（EM）是生产环境控制效果的评价工具，为了使洁净区的环境质量能得到有效控制和客观评价，应建立科学合理的监测计划，实施全面的监测，并对收集的数据加以有效的分析，将微生物和颗粒的污染风险最小化。',
          detailed:'<p> 1.EU GMP附录1消毒相关内容的解读</p> <p>1.1消毒剂剂的选择与使用</p> <p>1.2消毒剂的轮换</p> <p>1.3消毒剂的效力验证、使用有效期验证等。</p> <p>2.EU GMP附录1环境监测相关内容的解读</p> <p>2.1取样点、取样频率的评估</p> <p>2.2检测方法的确认</p> <p>2.3微生物鉴定、数据分析等。</p>   '
        },
        load_show:false,
        all_search:{
          input:'',
          list:[],
          type:'video'
        },
        type_list:[],
        screen_list:{
          screen_w:'',//宽度
          screen_h:'',
          user_list:[],
          list:[],
        },
        show:{
          list:[],
          tag:'',
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 9999,
          class_tyep:this.$route.query.type,//分类参数
          keyword:this.$route.query.keyword,//知识点搜索
          video_keyword:this.$route.query.video_keyword,//视频搜索
          selest:this.$route.query.selest,//只是点搜索
          type:'all',
          resource_type:'l',
          address:[],
          // class_tyep:0
        },
        search:'',
        activeIndex: '2',
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load
    },
    mounted:function(){
        this.get_type(this.show.class_tyep)

      this.screen_list.screen_w=this.$refs.screen_all.offsetWidth*0.5+'px'
      this.screen_list.screen_h=window.innerHeight*0.6+'px'
    },
    methods: {
      topping_click(){
        document.documentElement.scrollIntoView({ behavior: "auto" });
      },
      local_click(num){
        this.$router.push({path:'/visitor_Opencourses_tow',query:{type:num,}})
        this.$router.go(0)
      },
      get_type_click(num){
        this.$router.push({path:'/visitor_Opencourses_tow',query:{type:num,}})
        this.$router.go(0)
      },
      //视频跳转
      video_see(num,type,resource){
        const h = this.$createElement;
        this.$notify({
          title: '温馨提示',
          message: h('b', { style: 'color: red'}, '更多功能，请联系王老师:13260265598(手机、微信同号)'),
          duration: 0
        })
      },
      get_type(type){
        let _this=this;
        _this.load_show=true
        _this.axios.get('/v2/temp/lesson',{params:{type:type,limit:_this.show.pageSize,page:_this.show.currentPage}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.type_list=res.data.data.data
              _this.type_list_local=res.data.data.local
              _this.load_show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
    },

  }
</script>

<style scoped>
  .tag_true{
    background-color: #ecf5ff;
  }
  .tag_flast{
    background-color: white;
  }
  .shaixuan{
    overflow-y: auto;
  }
 >>> .el-col>.el-menu[data-v-1b536c89]{
    min-height:0;

  }
  .main {
    min-height: calc(100vh - 290px);
    width: 70%;
    padding: 0;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
    overflow: hidden;

  }

  h1 {
    /* color: white; */
    margin: 20px;
  }

  /* 导航 */
  .el-col>.el-menu {
    min-height: calc(100vh - 290px);
    overflow: hidden;
    padding: 20px 0;
    width: 100%;
  }

.el-menu--inline,
.el-menu-item-group>ul
.el-menu-item-group>ul>li{
    width: 100% !important;
  }

.el-menu-item-group__title {
    margin: 0;
    padding: 0;
  }

  #height1>i {
    /* color: white; */
  }

.el-submenu__title {
    width: 100%;
    height: 40px;
    min-height: 40px;
    line-height: 40px;
    font-weight: 600;
    padding: 0 !important;
  }

.el-icon-arrow-down{
    right: 0 !important;
  }
#height1>.el-submenu__title>span,
#height1>.el-menu-item {
    width: 100% !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: normal !important;
  }

  .el-submenu {
    width: 100%;
    /* margin-bottom: 20px; */
  }
/* 面包屑 */
.el-breadcrumb{
  margin: 35px;
}
  /* 卡片 */
  .el-row {
    width: 98%;
    padding-left: 2%;
  }

  .image {
    width: 100%;
    display: block;
    height: 100%;
    position: absolute;
  }
  .image1
  {
    width: 70%;
    /* margin-left: 10%; */
    display: block;
    height: 80%;
    position: absolute;
  }
  .image2
  {
    width: 1rem;
    height: 1rem;
  }
  .imgh {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }
  .imgh1 {
    width: 100%;
    /* padding-bottom: 56.25%; */
    background-image: url(../../../assets/video_type1.jpg);
    background-size: 100%;
     background-repeat:no-repeat;
     display: flex;
     justify-content: center;
     align-items: center;
     /* height: 0; */
     height: calc(15vh);
  }

  .eachc {
    margin: 10px;
    width: calc(25% - 20px);
  }
  .eachc1 {
    margin: 10px;
    width: calc(25% - 20px);
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  #height1 {
    /* background-color: rgb(51, 99, 151); */
    border-right: 2px dashed rgb(51, 99, 151);
    padding: 20px;

  }
     .el-menu{
       border: none;
     }
#text11 a{
  text-decoration:none;
}

.el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
    padding: 0 45px;
    min-width: 200px;
}
.router-link-active {
  text-decoration: none;
}
.topping{
  position: fixed;
  right:9%;
  bottom: 20px;
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
   background-color: white;
    border-radius: 4px;
    padding: 0.5rem;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/visitor/Courses/Opencourses_tow.vue